import { render } from "./CreateUpdateTenant.vue?vue&type=template&id=21601862"
import script from "./CreateUpdateTenant.vue?vue&type=script&lang=js"
export * from "./CreateUpdateTenant.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__